// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"acc9ee82","414":"da3539d7","542":"768e0151","645":"9c260dbb","747":"d36781c7","751":"2d55202c","818":"897ad96f","823":"405deb50","943":"f126a1d3","957":"7f591024"}[chunkId] + ".chunk.js";
};